import React from 'react'

import styles from "./styles/ContentContainer.module.scss";


interface ContainerProps {
    classes?: string;
    bg?: string;
    hasBoxShadow?: boolean;
    style?: React.CSSProperties;
    children: React.ReactNode;
}

const ContentContainer: React.FC<ContainerProps> = ({
    classes = "",
    style = {},
    bg = '',
    hasBoxShadow = true,
    children
}) => {
    return (
        <div
            className={`${styles.ContentContainer} ${classes}`}
            style={{
                ...style,
                ...(bg ? { backgroundColor: bg } : {}),
                ...(!hasBoxShadow ? { boxShadow: "none" } : {})
            }}
        >
            {children}
        </div >
    )
}

export default ContentContainer